import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import { ConfirmDialog } from '@/shared/dialogs/ConfirmDialog';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
    const resolveRef = useRef(null);
    const [state, setState] = useState({
        open: false,
        title: '',
        message: '',
        confirmLabel: 'Po',
        cancelLabel: 'Jo',
        variant: 'danger',
    });

    const confirm = useCallback((options = {}) => {
        return new Promise((resolve) => {
            resolveRef.current = resolve;
            setState({
                open: true,
                title: options.title || 'Konfirmo',
                message: options.message || 'A jeni të sigurt?',
                confirmLabel: options.confirmLabel || 'Po',
                cancelLabel: options.cancelLabel || 'Jo',
                variant: options.variant || 'danger',
            });
        });
    }, []);

    const handleClose = useCallback((value) => {
        resolveRef.current?.(value);
        resolveRef.current = null;
        setState((s) => ({ ...s, open: false }));
    }, []);

    return (
        <ConfirmContext.Provider value={{ confirm }}>
            {children}
            <ConfirmDialog
                open={state.open}
                title={state.title}
                message={state.message}
                confirmLabel={state.confirmLabel}
                cancelLabel={state.cancelLabel}
                variant={state.variant}
                onCancel={() => handleClose(false)}
                onConfirm={() => handleClose(true)}
            />
        </ConfirmContext.Provider>
    );
}

export function useConfirm() {
    const ctx = useContext(ConfirmContext);
    if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
    return ctx;
}
